import { render } from "./Navbar.vue?vue&type=template&id=2969ec92"
const script = {}

import "./Navbar.vue?vue&type=style&index=0&id=2969ec92&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__